// extracted by css-extract-rspack-plugin
export default {"iconButton":"SearchButton-module__iconButton___Gw4Bu","searchTextButton":"SearchButton-module__searchTextButton___siit6","shortcutText":"SearchButton-module__shortcutText___K0fzS"};